<template>
  <footer class="d-flex align-items-center justify-content-between stihl-footer">

    <div class="d-flex footer-links">
      <span>
        <a target="_blank" rel="noopener noreferrer" :href="localizedLink(config.legal.imprint_url)">
          {{ $t('adm.footer.imprint') }}</a>
      </span>
      <span>
        <a target="_blank" rel="noopener noreferrer" :href="localizedLink(config.legal.terms_url)">
          {{ $t('adm.footer.terms') }}</a>
      </span>
      <span>
        <a target="_blank" rel="noopener noreferrer" :href="localizedLink(config.legal.privacy_url)">
          {{ $t('adm.footer.privacy') }}</a>
      </span>
    </div>

    <div class="footer-address">
      <span class="address">{{ $t('adm.footer.legalEntity') }}</span>
    </div>

  </footer>
</template>

<script lang="ts">

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StihlFooter',
  data() {
    return {
      config: window.APP_CONFIG,
    };
  },
  methods: {
    localizedLink(links: Record<string, string>) {
      return links[this.$i18n.locale] ?? links.en;
    },
  },
});
</script>

<style scoped>

</style>
